module.exports = __webpack_public_path__ + "static/media/getty_icon.20522310.svg";